import { Style } from "@client/style";
import { css } from "@emotion/css";
import { Modal, ModalFuncProps, ModalProps } from "antd";
import React from "react";

export namespace Md {
  export const pageWidth = "75vw";

  export const fnWidth = "55vw";

  export const pageProps: ModalProps = {
    width: pageWidth,
    centered: true,
    closable: false,
    visible: true,
    maskClosable: false,
    okText: "确定",
    cancelText: "取消",
    okButtonProps: { className: Style.btnPrimarySm },
    cancelButtonProps: { className: Style.btnWarningSm },
  };

  export const fnProps: ModalFuncProps = {
    ...pageProps,
    width: fnWidth,
    title: false,
    icon: false,
  };
}

export function modalConfirm({ content, onOk, ...props }: ModalFuncProps) {
  return Modal.confirm({
    ...Md.fnProps,
    ...props,
    content: (
      <div
        className={css`
          font-size: 1.5rem;
          min-height: 12rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        `}
      >
        {content}
      </div>
    ),
    onOk: () => {
      onOk()?.then();
    },
  });
}
